import { Button, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <Container
      maxWidth="sm"
      style={{ marginTop: "100px", textAlign: "center" }}
    >
      <Typography
        variant="h1"
        style={{ fontSize: "180px", fontWeight: "bold", color: "#CCCCCC" }}
      >
        404
      </Typography>
      <Typography variant="h4" gutterBottom>
        Oops! Page not found.
      </Typography>
      <Typography variant="body1" gutterBottom>
        We can't seem to find the page you're looking for.
      </Typography>
      <Button variant="contained" color="primary" component={Link} to="/">
        Go to Home
      </Button>
    </Container>
  );
}
